import React, { useRef, useState } from 'react';

//
// <SmoothImage/> — drop-in <img> replacement that fades + lifts on load.
// Renders a teal shimmer placeholder behind the image until it decodes,
// then swaps via .is-loaded. Honours prefers-reduced-motion through CSS.
//
// Props: same as <img/>, plus optional `containerClassName` for the wrapper
// (e.g. to constrain aspect ratio / border-radius / shadow).
//
export default function SmoothImage({
  src,
  alt = '',
  className = '',
  containerClassName = '',
  draggable = false,
  loading = 'lazy',
  decoding = 'async',
  ...rest
}) {
  const [loaded, setLoaded] = useState(false);
  const imgRef = useRef(null);

  // If the image is already cached the load event may have fired before
  // React attached the ref — sync once on mount.
  const handleRef = (node) => {
    imgRef.current = node;
    if (node && node.complete && node.naturalWidth > 0) setLoaded(true);
  };

  return (
    <div className={`relative ${containerClassName}`}>
      {!loaded && (
        <div className="absolute inset-0 img-shimmer" aria-hidden="true" />
      )}
      <img
        ref={handleRef}
        src={src}
        alt={alt}
        loading={loading}
        decoding={decoding}
        draggable={draggable}
        onLoad={() => setLoaded(true)}
        className={`img-fade ${loaded ? 'is-loaded' : ''} ${className}`.trim()}
        {...rest}
      />
    </div>
  );
}
